import { Button } from '@sunwebgroup/uds-ui/button'
import * as Collapsible from '@sunwebgroup/uds-ui/collapsible'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { isEmpty } from 'ramda'
import * as React from 'react'
import { useIntl } from '@/intl'
import { getRoomsResponseSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './AgeProfiles.module.css'

export function AgeProfiles() {
  const intl = useIntl()
  const { specialAgeProfiles } = usePricesSelector(getRoomsResponseSelector)
  const readLess = React.useMemo(() => intl.formatMessage({ id: 'prices_room_selector_read_less' }), [intl])
  const readMore = React.useMemo(() => intl.formatMessage({ id: 'prices_room_selector_read_more' }), [intl])
  const [toggleText, setToggleText] = React.useState(readMore)

  const onChangeCollapsible = React.useCallback(
    (open: boolean) => {
      setToggleText(open ? readLess : readMore)
    },
    [readLess, readMore],
  )

  if (!specialAgeProfiles || isEmpty(specialAgeProfiles))
    return null

  const translationIds: Record<string, string> = {
    adults: 'quicksearch_filter_participants_adults',
    children: 'quicksearch_filter_participants_children',
    babies: 'quicksearch_filter_participants_babies',
  }

  return (
    <Collapsible.Root onOpenChange={onChangeCollapsible}>
      <div className={styles.ageProfiles}>
        <Typography variant="body-m-bold-flat">
          {intl.formatMessage({ id: 'prices_room_selector_age_profiles_title' })}
        </Typography>
        <Collapsible.Content className={styles.content}>
          <div className={styles.details}>
            <Typography variant="body-m-regular-snug">
              {intl.formatMessage({ id: 'prices_room_selector_age_profiles_description' })}
            </Typography>
            <div className={styles.ranges}>
              {Object.entries(specialAgeProfiles).map(([ageProfile, ageRange]) => (
                <div className={styles.ageProfile} key={ageProfile}>
                  <Typography variant="body-m-bold-flat">{intl.formatMessage({ id: translationIds[ageProfile] })}</Typography>
                  <Typography variant="body-m-regular-snug">
                    {intl.formatMessage(
                      { id: 'prices_room_selector_age_profiles_range_description' },
                      { minAge: ageRange?.minAge, maxAge: ageRange?.maxAge },
                    )}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </Collapsible.Content>
        <Collapsible.Trigger asChild>
          <Button className={styles.collapseButton} variant="transparentNeutral">
            {toggleText}
          </Button>
        </Collapsible.Trigger>
      </div>
    </Collapsible.Root>
  )
}
